import React from 'react';
import { cn } from './cn';

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, ...props }, ref) => (
    <label className="ds-checkbox-wrapper">
      <input
        type="checkbox"
        ref={ref}
        className={cn('ds-checkbox', className)}
        aria-checked={props.checked}
        {...props}
      />
      {label ? <span className="ds-checkbox-label">{label}</span> : null}
    </label>
  )
);

Checkbox.displayName = 'Checkbox';
